import { Close } from '@mui/icons-material';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { CSSProperties, ReactNode } from 'react';
import { Dialog as MuiDialog, DialogContent, DialogTitle, Box } from '@mui/material';
import { convertToKebabCase } from '../../../constants/helpers/text';

const StyledDialog = withStyles((theme: Theme) => ({
  paper: {
    background: theme.palette.background.paper,
    borderRadius: theme.customComponents.card.borderRadius,
    boxShadow: theme.customComponents.card.boxShadow,
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      width: '100%',
      minHeight: '100%',
      borderRadius: 0,
      boxShadow: 'none'
    }
  }
}))(MuiDialog);

const StyledDialogContent = withStyles((theme: Theme) => ({
  root: {
    height: '100%',
    width: '600px',
    background: theme.palette.background.default,
    padding: theme.spacing(3),
    paddingTop: `${theme.spacing(2)} !important`,
    boxShadow: `${theme.customComponents.card.boxShadow} !important`,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minHeight: '100%',
      boxShadow: 'none'
    }
  }
}))(DialogContent);

interface Props {
  children: ReactNode;
  open: boolean;
  title: string;
  width?: CSSProperties['width'];
  minHeight?: CSSProperties['minHeight'];
  height?: string;
  handleClose?: () => void;
  disableBackdropClose?: boolean;
  locked?: boolean;
  ignoreMinHeight?: boolean;
}

const Dialog = ({
  children,
  handleClose = () => {},
  open,
  title,
  width = 'auto',
  minHeight = '200px',
  height,
  disableBackdropClose = false,
  locked = false,
  ignoreMinHeight = false
}: Props) => (
  <StyledDialog
    PaperProps={{
      sx: {
        height
      }
    }}
    onClose={(event, reason) => {
      if (reason === 'backdropClick' && disableBackdropClose) {
        return;
      }

      handleClose();
    }}
    aria-labelledby={title}
    open={open}
    disableEscapeKeyDown={locked}
    maxWidth={false}
  >
    <DialogTitle>
      <Box width={width} display="flex" justifyContent="space-between">
        {title}
        {handleClose && !locked && <Close data-testid="modal-close-icon" cursor="pointer" onClick={handleClose} />}
      </Box>
    </DialogTitle>
    <StyledDialogContent>
      <Box
        data-testid={`${convertToKebabCase(title)}-tab`}
        width={width}
        minHeight={ignoreMinHeight ? undefined : minHeight}
      >
        {children}
      </Box>
    </StyledDialogContent>
  </StyledDialog>
);

export default Dialog;
